import React, { Component } from "react";

class RadioGroup extends Component {
  render() {
    const {
      register,
      errors,
      label,
      name,
      rules,
      options,
      disabled,
      className,
      styles,
      labelClassName,
      labelStyles,
    } = this.props;

    return (
      <div className={`flex flex-col items-start ${className}`}>
        <label
          htmlFor={name}
          className={`form-label font-bold float-start mb-1 ${labelClassName}`}
          style={labelStyles}
        >
          {rules?.required && <span className="text-red-500">*</span>} {label}
        </label>
        <div className="flex flex-col items-start">
          {options?.map((option, index) => (
            <div key={index} className="flex items-center mb-1">
              <input
                {...register(name, rules)}
                type="radio"
                value={option.value}
                disabled={disabled}
                className={`h-3 w-3 text-blue-600 border-gray-300 rounded-full focus:ring-blue-500 ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
                style={styles}
                aria-invalid={!!errors[name]}
                aria-describedby={errors[name] ? `${name}-error` : undefined}
              />
              <label
                htmlFor={`${name}-${option.value}`}
                className="ml-2 form-label"
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
        {errors[name] && (
          <span id={`${name}-error`} className="text-red-500 text-sm mt-1">
            {errors[name].message}
          </span>
        )}
      </div>
    );
  }
}

export default RadioGroup;